<template>
  <div class="sale-form-container">
    <Panel title="5.ข้อมูลผู้เสนอขาย" isShowCollapsible isCollapse>
      <div class="sale-form row clearfix">
        <div class="form-group col-sm-6">
          <div class="input-group">
            <span class="input-group-addon nobd-nobg">นำเสนอโดย</span>
            <input type="text" class="form-control input-sm" v-model="fullname" disabled />
          </div>
        </div>
        <div class="form-group col-sm-6">
          <div class="input-group">
            <span class="input-group-addon nobd-nobg">เลขที่ใบอนุญาติ</span>
            <input type="text" class="form-control input-sm" v-model="licenseNumber" disabled />
          </div>
        </div>
        <div class="form-group col-sm-12">
          <div class="input-group">
            <span class="input-group-addon nobd-nobg">ธนาคารทหารไทยธนชาต จำกัด (มหาชน) สาขา</span>
            <input type="text" class="form-control input-sm" v-model="branchName" disabled />
          </div>
        </div>
        <div class="form-group col-sm-6">
          <div class="input-group">
            <span class="input-group-addon nobd-nobg">วันที่นำเสนอ</span>
            <input type="text" class="form-control input-sm" v-model="datetime" disabled />
          </div>
        </div>
      </div>
    </Panel>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapActions } from 'vuex'
import { mapGetters } from 'vuex'
import moment from 'moment'

import Panel from '@/components/Panel'
import { DATE_FORMAT } from '@/lib/global'

export default {
  name: 'SaleForm',
  data() {
    return {
      fullname: '-',
      licenseNumber: '-',
      branchName: '-',
      datetime: '-',
    }
  },
  mounted() {
    const { auth_from, staffInfo } = this.$session.get('chili')

    this.datetime = moment().format(DATE_FORMAT)

    if (auth_from === 'tmb') {
      const { licenseNumber, branchName, title, firstname, lastname } = staffInfo

      this.licenseNumber = licenseNumber
      this.branchName = branchName
      this.firstname = firstname
      this.lastname = lastname
      this.fullname = `${title} ${firstname} ${lastname}`
    }
  },
  computed: {
    ...mapGetters(['dateToday']),
  },
  components: {
    Panel,
  },
  methods: {
    showToggle() {
      this.showToggleHaed = !this.showToggleHaed
      this.showToggleBody = !this.showToggleBody
    },
  },
}
</script>

<style lang="scss"></style>
